module.exports = __webpack_public_path__ + "static/media/wgl1.png.b6700dc5.jpg";